<div [class.ks-no-records]="!(loading$ | async) && !(items$ | async)?.length" class="ks-table">
  <div [hidden]="hideFilters" class="ks-table-filters ks-mb-4">
    <div *ngIf="customFilters.length" class="ks-table-filters__custom ks-mr-auto">
      <div *ngFor="let filter of customFilters; let idx = index">
        <button
          type="button"
          class="ks-btn-link-{{ idx === activeCustomFilterIdx ? 'primary' : 'neutral' }}"
          (click)="applyCustomFilter(idx, filter)"
        >
          {{ filter.label }}
        </button>
        <span *ngIf="idx === activeCustomFilterIdx" class="ks-badge-sm">{{
          totalCount$ | async
        }}</span>
      </div>
    </div>
    <div *ngIf="toggleableColumns.length" class="ks-table-filters__toggle ks-mr-4">
      <ng-container *ngFor="let column of toggleableColumns">
        <div class="ks-toggle-field" (click)="applyToggleFilter(column.columnDef)">
          <ng-container
            *ngTemplateOutlet="
              column.toggleTemplate;
              context: { $implicit: getFilterFormControl(column.columnDef) }
            "
          ></ng-container>
        </div>
      </ng-container>
    </div>
    <div class="ks-table-filters__search">
      <kt-input
        #searchInput
        [type]="'text'"
        [label]="'Search'"
        [control]="searchControl"
      ></kt-input>
      <button type="button" class="ks-btn-md ks-btn-outline-primary" (click)="toggleFilterRow()">
        Filters
      </button>
    </div>
  </div>
  <mat-table
    matSort
    [dataSource]="(loading$ | async) ? [].constructor(defaultPageSize) : (items$ | async)"
    [class.loading]="loading$ | async"
    class="ks-table-body ks-scrollbar-neutral"
  >
    <ng-container *ngFor="let column of columns">
      <ng-container [matColumnDef]="column.columnDef">
        <mat-header-cell
          *matHeaderCellDef
          [mat-sort-header]="column.columnDef"
          [class.not-sortable]="!column.sortable"
        >
          {{ column.header }}
        </mat-header-cell>
        <mat-cell *matCellDef="let item; let index = index">
          <ng-container *ngIf="item">
            <ng-container *ngIf="column.template; else defaultCell">
              <ng-container
                *ngTemplateOutlet="
                  column.template;
                  context: { $implicit: item, index: index, loadItems: loadItemsList.bind(this) }
                "
              ></ng-container>
            </ng-container>
            <ng-template #defaultCell>
              <div *ngIf="column.cell(item)" [innerHTML]="column.cell(item) | safe : 'html'"></div>
            </ng-template>
          </ng-container>
        </mat-cell>
      </ng-container>
      <ng-container [matColumnDef]="column.columnDef + 'Filter'">
        <mat-header-cell *matHeaderCellDef>
          <ng-container *ngIf="column.columnDef !== 'actions'; else actionsFilter">
            <ng-container
              *ngTemplateOutlet="
                column.filterTemplate;
                context: { $implicit: filterForm.get(column.columnDef + 'Filter') }
              "
            ></ng-container>
          </ng-container>
          <ng-template #actionsFilter>
            <button
              type="button"
              class="ks-btn-md ks-btn-outline-neutral ks-mr-2"
              (click)="resetFilter()"
            >
              Reset
            </button>
            <button
              type="button"
              class="ks-btn-md ks-btn-outline-primary"
              (click)="reloadItemsList()"
            >
              Apply
            </button>
          </ng-template>
        </mat-header-cell>
      </ng-container>
    </ng-container>
    <mat-header-row *matHeaderRowDef="columnsDef"></mat-header-row>
    <mat-header-row
      *matHeaderRowDef="filterColumnsDef"
      [class.hidden]="!showFilterRow"
    ></mat-header-row>
    <mat-row *matRowDef="let row; columns: columnsDef"></mat-row>
  </mat-table>
  <div *ngIf="!(loading$ | async) && !(items$ | async)?.length" class="ks-table-message">
    <span inlineSVG="assets/illustrations/no-records.svg"></span>
  </div>
  <mat-paginator
    [hidden]="hidePagination"
    [pageSizeOptions]="pageSizeOptions"
    [pageSize]="paginator.pageSize || defaultPageSize"
    [length]="totalCount$ | async"
    [showFirstLastButtons]="true"
    class="ks-table-paginator"
  ></mat-paginator>
</div>
